import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pUiLog, rCore } from '../../models/.catalog';

export default class UiLogEkleApi extends ApiBase<pUiLog, rCore> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/Ekle',
      }),
      options
    );
    this._ServiceUrl = '/services/UiLog.asmx';
  }
}
